module.exports = __webpack_public_path__ + "img/Feature.f0f05ef2.png";